import { Skeleton } from "@/app/components/shadcn/skeleton";

const MyBasketPageSkeleton = () => {
  return (
    <section className="container-minify py-4 lg:py-8">
      <div className="flex items-center justify-between mb-4 lg:mb-6">
        <Skeleton className="h-8 lg:h-10 w-32" />
        <Skeleton className="h-6 w-20" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
        <div className="lg:col-span-8 space-y-4">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="bg-white rounded-lg border p-4">
              <Skeleton className="h-6 w-32 mb-4" />
              <Skeleton className="h-32 w-full" />
            </div>
          ))}
        </div>
        <div className="lg:col-span-4">
          <div className="bg-white rounded-lg border p-6">
            <Skeleton className="h-6 w-32 mb-4" />
            <div className="space-y-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-4 w-full" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyBasketPageSkeleton;